import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Ctcae5 from '../ctcae5/ctcae';
import Ctcae6 from '../ctcae6/ctcae';
import Login from '../login/login';
import Signup from '../signup/signup';
import './main.css';

const Main = () => (
    <div className="main-container">
        <Switch>
            <Route exact path='/'>
                <Redirect to='/ctcae6' />
            </Route>
            <Route path='/ctcae5' component={Ctcae5}/>
            <Route path='/ctcae6' component={Ctcae6}/>
            <Route path='/login' component={Login}/>
            <Route path='/signup' component={Signup}/>
        </Switch>
    </div>
);

export default Main



// WEBPACK FOOTER //
// ./src/component/main/main.js